import { categories } from "@/mocks/positiveNews";

export default function CategoriesSection() {
  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-400" />
            主题栏目 · COLUMNS
            <span className="h-px w-6 bg-primary-400" />
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">从哪个栏目开始读？</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            我们把温暖分门别类，方便你快速找到此刻最想看的红料。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c, idx) => (
            <a
              key={c.key}
              href={idx === 0 ? "#hot" : idx === 1 ? "#featured" : idx === 3 ? "#people" : "#collections"}
              className="group relative block overflow-hidden rounded-2xl cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden md:h-72">
                <img
                  src={c.img}
                  alt={`${c.label}精选红料`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <span className="inline-block rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                    {c.label}
                  </span>
                  <h3 className="mt-3 font-heading text-xl font-bold text-background-50 md:text-2xl">{c.tagline}</h3>
                  <p className="mt-1 text-sm text-background-200">已收录 {c.count.toLocaleString()} 条红料</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-sm text-accent-200">
                    进入栏目
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </div>
            </a>
          ))}

          {/* 补位 CTA 卡片 */}
          <a
            href="#collections"
            className="group relative flex min-h-[16rem] flex-col items-start justify-center overflow-hidden rounded-2xl bg-primary-600 p-6 transition-colors hover:bg-primary-700 cursor-pointer md:min-h-[18rem]"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50/15 text-accent-300">
              <i className="ri-stack-line text-2xl" />
            </span>
            <h3 className="mt-4 font-heading text-xl font-bold text-background-50 md:text-2xl">红料合集专题</h3>
            <p className="mt-2 text-sm text-background-100">把热门故事按专题整理，一口气看个够。</p>
            <span className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors group-hover:bg-accent-500 group-hover:text-foreground-950">
              前往红料合集
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}